import { InjectionToken } from '@angular/core';
import { io } from 'socket.io-client';

export type SocketIoFactory = typeof io;

export const SOCKET_IO = new InjectionToken<SocketIoFactory>('SOCKET_IO', {
  providedIn: 'root',
  factory: () => io,
});
